import React, { Component } from 'react';
import SideBar from './StudentComponents/Sidebar';
import { Redirect, Route, Link, Switch } from 'react-router-dom';
import ContentArea from './StudentComponents/ContentArea';
import superagent from 'superagent';
import ReactLoading from 'react-loading';



class Student extends Component {

  constructor(props) {
    super(props);

     this.state={
       access_token:this.props.admin_token,
       user_details:this.props.admin_details,
       loading:true,
       loaded_successfully:false,
       api_error_message:"",
       server_changes_made:""
     }
  }

  componentWillMount(){

  }

  render() {
    const _this=this;


    if(! this.props.loginStatus)
    {
      return(<Redirect to = "/student/login"/>);
    }

      return (
        <div className = "wrapper">
          <SideBar student_details = {_this.props.student_details}/>
          <ContentArea      student_details = {_this.props.student_details}
                            base_url={_this.props.base_url}
                            loginStatus= {this.props.loginStatus}
                            renderInThousands = {this.props.renderInThousands}
                            updateStudentDetails={_this.props.updateStudentDetails}/>
        </div>

      );

    //}


  }




}

export default Student;
